import { render, staticRenderFns } from "./PointsPage.vue?vue&type=template&id=0f51e7c6&scoped=true&"
import script from "./PointsPage.vue?vue&type=script&lang=js&"
export * from "./PointsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f51e7c6",
  null
  
)

export default component.exports